<template>
  <div>
    <div id="home"></div>

    <v-img src="/static/img/cafe/1.jpg" class="rooms-img">
      <div class="offer1-mask text-xs-center">
        <v-container>
          <div class="offer1-offer">Уютное кафе в центре города</div>
          <div class="offer1-sub-offer">Проводим дни рождения, юбилей, торжества, банкеты.</div>

          <app-modal-form
            button-text="Забронировать кафе"
            modal-form-header="Забронируйте"
            modal-form-sub-header="кафе прямо сейчас"
            modal-form-button-text="Забронировать кафе"
            form-name="Акрополь - Кафе - главный"
          ></app-modal-form>

        </v-container>
      </div>
    </v-img>

    <v-container class="screen">
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <h1>Фото</h1>
        </v-flex>
      </v-layout>
    </v-container>

    <app-acropolis-gallery-cafe></app-acropolis-gallery-cafe>
    <app-acropolis-reviews></app-acropolis-reviews>
    <app-acropolis-contacts></app-acropolis-contacts>

    <app-button-go-back :goto="goto"></app-button-go-back>

  </div>
</template>

<script>
export default {
  data () {
    return {
      goto: { path: '/acropolis' }
    }
  }
}
</script>

<style scoped>
#home {
  position: relative;
  top: -150px;
}

.rooms a,
.rooms a:active,
.rooms a:hover,
.rooms a:visited {
  color: black;
  text-decoration: none;
}

.rooms-img {
  height: 80vh;
}

.rooms h1 {
  margin-bottom: 50px;
}

.rooms-block {
  margin: 15px;
  text-align: center;
  border: 1px solid #c3c3c3;
  border-radius: 5px;
}

.rooms-block:hover {
  background-color: #f5f5f5;
  opacity: 0.8;
}

.rooms-h1 {
  font-size: 21px;
  font-weight: 900;
  margin-top: 15px;
}

.rooms-description {
  margin-top: 10px;
  margin-bottom: 10px;
}

.rooms-price {
  font-size: 21px;
  font-weight: 900;
  color: green;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  .rooms h1 {
    margin-bottom: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/acropolis/Cafe.vue